import { __decorate } from "tslib";
import { Component, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { ComponentService } from '../../services/component.service';
import { SlipModalComponent } from '../slip-modal';
import { ConfirmComponent } from '../confirm';
import { CountdownComponent } from 'ngx-countdown';
import { SpinnerService } from '../spinner/spinner.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
import { Router } from "@angular/router";
/**
 *  TransactionComponent
 */
let TransactionsComponent = class TransactionsComponent {
    constructor(httpClient, compService, spinner, webSettingsService, sanitizer, themeService, datepipe, router) {
        this.httpClient = httpClient;
        this.compService = compService;
        this.spinner = spinner;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.datepipe = datepipe;
        this.router = router;
        this.cnts = [];
        this.transactions = [];
        this.slice = 10;
        this.status = {};
        this.userData = {};
        this.tableLoading = false;
        this.color = '';
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.shortUserType = '';
        this.currentMargin = '';
        this.error = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.cardsShow = localStorage.getItem('cardsActive');
        this.addressLengthBreakpoint = 20;
        this.csvDownloading = false;
        const lang = localStorage.getItem('language');
        this.themeService.getTheme().subscribe((data) => {
            this.color = this.themeService.getStyleAttribute('text_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.httpClient.get('user/statusrequirement').subscribe((data) => {
            this.status = data;
            const currentAmount = this.status.current_amount;
            if (this.status.start_day !== null) {
                const date = new Date(this.status.start_day);
                this.status.start_day = this.datepipe.transform(date, 'dd.MM.yyyy');
                ;
            }
            this.webSettingsService.getSettings().subscribe((data) => {
                const key = ('TRANSACTIONS.' + this.status.user_type + '_SHORT').toUpperCase();
                this.shortUserType = this.webSettingsService.getKeyValue(key);
                const currency = this.webSettingsService.getKeyValue('TRANSACTION.CURRENCY');
                const current = currentAmount + ' ' + currency;
                const length = current.length;
                this.currentMargin = '-' + 4 * length + 'px';
            });
            this.status.currentAmount = (typeof this.status.current_amount !== undefined) ?
                (Math.round(parseFloat(this.status.current_amount + ''))).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : '';
            this.status.totalAmount = (typeof this.status.total_amount !== undefined) ?
                (Math.round(parseFloat(this.status.total_amount + ''))).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : '';
            this.status.requiredAmount = (typeof this.status.required_amount !== undefined) ?
                (Math.round(parseFloat(this.status.required_amount + ''))).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : '';
            this.status.minimumAmount = (typeof this.status.minimum_amount !== undefined) ?
                (Math.round(parseFloat(this.status.minimum_amount + ''))).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : '';
            if (typeof this.status.percentage !== undefined) {
                if (this.status.percentage.toString().indexOf('.') !== -1) {
                    if (this.status.percentage.toString().indexOf('.00') !== -1) {
                        this.status.percent = this.status.percentage.toString().split('.')[0];
                    }
                    else {
                        this.status.percent = this.status.percentage.toString().replace('.', ',');
                    }
                }
                else {
                    this.status.percent = this.status.percentage + '';
                }
            }
            else {
                this.status.percent = '';
            }
        });
        this.httpClient.get('user/data').subscribe((data) => {
            this.userData = data;
            this.userType = this.userData.user_type_id.type;
        });
        this.getTransactions();
    }
    ngAfterViewInit() {
    }
    ngOnInit() {
    }
    goToBankPayment(id) {
        this.cardPaymentComponent.paymentRequestDetails(id);
    }
    openModal(id) {
        this.compService.openModal(SlipModalComponent, {
            order_id: id
        });
    }
    getTransactions() {
        this.tableLoading = true;
        this.httpClient.get('market/user/orders').subscribe((data) => {
            const trns = Object.values(data);
            for (let i = 0; i < trns.length; i++) {
                if (trns[i].payment_expires_timestamp === null && trns[i].payment_can_expire) {
                    this.onFinishedSingleOrder(trns[i]);
                }
            }
            this.cntdComponents.changes.subscribe(() => {
                this.cnts = this.cntdComponents.toArray();
                for (let i = 0; i < trns.length; i++) {
                    if (trns[i].payment_expires_timestamp !== null && trns[i].payment_can_expire) {
                        this.setCounterTimeLeft(i);
                    }
                }
            });
            this.transactions = trns;
            this.tableLoading = false;
        }, (error) => {
            this.tableLoading = false;
            console.error(error);
        });
    }
    uploadDocumentation(orderId) {
        this.router.navigateByUrl('/documentation/' + orderId);
    }
    goToConfirmation(orderId, orderType) {
        this.router.navigateByUrl('/' + orderType + '/confirm/' + orderId);
    }
    download() {
        this.error = '';
        this.downloadReport().subscribe((data) => {
            let contentDisposition = '';
            let filename = '';
            contentDisposition = data.headers.get('Content-Disposition') !== null ? data.headers.get('Content-Disposition') : '';
            if (contentDisposition.length < 4) {
                filename = contentDisposition.substring(contentDisposition.indexOf('"') + 1, contentDisposition.lastIndexOf('"'));
            }
            if (!filename.includes('.csv')) {
                filename = this.userData.username ? this.userData.username + '.csv' : 'transactions.csv';
            }
            saveAs(data.body, filename);
            this.csvDownloading = false;
        }, err => {
            this.error = 'EXPORT_TRANSACTIONS.ERROR';
            this.csvDownloading = false;
        });
    }
    downloadReport() {
        let lang = localStorage.getItem('language');
        if (lang === null) {
            lang = this.webSettingsService.getCurrentLanguage();
        }
        const url = 'market/user/orders/getuserorders';
        const body = { verbose_id: lang };
        return this.httpClient.downloadFile(url, body);
    }
    getCSV() {
        this.error = '';
        this.csvDownloading = true;
        this.httpClient.get('market/user/orders/checkuserorders').subscribe((success) => {
            this.download();
        }, (error) => {
            this.error = 'EXPORT_TRANSACTIONS.' + error.error['message'];
        });
    }
    refreshTable() {
        this.error = '';
        this.getTransactions();
    }
    delete(id, event, i) {
        this.compService.openModal(ConfirmComponent, {
            title: 'DELETE_TRANSACTION'
        }, (success) => {
            const targ = event.target || event.srcElement;
            this._cancelOrder(this.transactions[i], true, targ);
        });
    }
    loadMore() {
        this.slice = this.slice + 10;
    }
    onFinishedSingleOrder(order) {
        if (order.is_payment_expiration_terminal && order.status === 'received' && order.payment_can_expire) {
            order.status = 'waiting_for_cancelation';
            order.payment_expires_timestamp = null;
        }
        else if (!order.is_payment_expiration_terminal && order.status === 'received' && order.payment_can_expire) {
            order.payment_expires_timestamp = null;
        }
    }
    setCounterTimeLeft(transactionIndex) {
        const expiresAtUTC = this.transactions[transactionIndex].payment_expires_timestamp;
        const currentTime = new Date().getTime();
        const res = (expiresAtUTC - currentTime / 1000);
        if (res <= 0) {
        }
        else {
            this.cnts[transactionIndex].config.leftTime = parseInt(res + '');
            this.cnts[transactionIndex].restart();
        }
    }
    handleEvent(event, item) {
        if (event.action === 'done') {
            this.onFinishedSingleOrder(item);
        }
    }
    showAddressWithEllipsis(address) {
        return address.substr(0, 10) + '...' + address.substr(address.length - 10, address.length);
    }
    _cancelOrder(order, withAPISupport, targ) {
        if (withAPISupport) {
            this.httpClient.post('market/order/resetorder', { order_id: order.id }).subscribe((data) => {
                order.status = 'canceled';
                order.payment_expires_timestamp = null;
                targ.remove();
            });
        }
        else {
            order.status = 'canceled';
            order.payment_expires_timestamp = null;
        }
    }
    copyAddress(item) {
        document.addEventListener('copy', (e) => {
            e.clipboardData.setData('text/plain', (item.deposit_address));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
        item.copied = true;
        setTimeout(() => {
            item.copied = false;
        }, 1000);
    }
};
TransactionsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ComponentService },
    { type: SpinnerService },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: DatePipe },
    { type: Router }
];
__decorate([
    ViewChildren(CountdownComponent)
], TransactionsComponent.prototype, "cntdComponents", void 0);
__decorate([
    ViewChild('cardPaymentDetailsTransactionsList', { static: true })
], TransactionsComponent.prototype, "cardPaymentComponent", void 0);
TransactionsComponent = __decorate([
    Component({
        selector: 'ecd-single-transactions',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./transactions.component.html")).default,
        providers: [DatePipe]
    })
], TransactionsComponent);
export { TransactionsComponent };
